import React, { KeyboardEvent, useRef, useEffect } from 'react';
import { useChatWidgetContext } from 'features/nekst-widgets';

export default function FullPageComposer() {
  const {
    sendMessage,
    isStreaming,
    inputText,
    setInputText,
  } = useChatWidgetContext();

  const textareaRef = useRef<HTMLTextAreaElement>(null);

  useEffect(() => {
    if (textareaRef.current) {
      textareaRef.current.style.height = 'auto';
      textareaRef.current.style.height = `${Math.min(textareaRef.current.scrollHeight, 128)}px`;
    }
  }, [inputText]);

  const handleKeyDown = (e: KeyboardEvent<HTMLTextAreaElement>) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      sendMessage();
    }
  };

  const canSend = !isStreaming && inputText.trim().length > 0;

  return (
    <div
      className="flex flex-col rounded-[16px] border border-gray-200 bg-white transition-colors focus-within:border-gray-300"
      style={{ padding: '8px 4px' }}
    >
      <textarea
        ref={textareaRef}
        className="w-full resize-none font-[inherit] placeholder:text-gray-400"
        style={{ minHeight: '56px', maxHeight: '128px', padding: '8px 16px 12px', fontSize: '14px', lineHeight: '1.5', backgroundColor: 'transparent', border: 'none', outline: 'none' }}
        placeholder="Send a message..."
        value={inputText}
        onChange={(e) => setInputText(e.target.value)}
        onKeyDown={handleKeyDown}
        disabled={isStreaming}
        rows={1}
        data-testid="chat-message-input"
      />
      <div className="flex items-center justify-between" style={{ padding: '0 8px 4px' }}>
        <button
          type="button"
          className="inline-flex items-center justify-center rounded-full border-none bg-transparent text-gray-700 cursor-pointer"
          style={{ width: '34px', height: '34px', fontSize: '20px', lineHeight: 1, padding: 0 }}
          disabled
          title="Add attachment"
        >
          +
        </button>
        <button
          type="button"
          className={`inline-flex items-center justify-center rounded-full border-none ${
            canSend
              ? 'bg-gray-900 text-white cursor-pointer'
              : 'bg-gray-200 text-gray-400 cursor-default'
          }`}
          style={{ width: '34px', height: '34px', fontSize: '20px', lineHeight: 1, padding: 0 }}
          onClick={sendMessage}
          disabled={!canSend}
          data-testid="chat-send-button"
          title="Send message"
        >
          &#8593;
        </button>
      </div>
    </div>
  );
}
